import {
  Validators,
  type AbstractControl,
  type ValidationErrors,
} from '@angular/forms';

import { type QuestionValidator } from './interfaces';

export const requiredValidator: QuestionValidator = function (
  _: AbstractControl,
  value: string,
): ValidationErrors | null {
  return Validators.required({
    value,
  } as AbstractControl);
};
